// ui/common/bit/InvestChangeArrow.tsx

import React from "react"

interface InvestChangeArrowProps {
  direction?: "up" | "down"
  color?: string
  className?: string
  style?: React.CSSProperties
}

const InvestChangeArrow: React.FC<InvestChangeArrowProps> = ({
  direction = "up",
  color,
  className,
  style,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="12"
    viewBox="0 0 9 12"
    fill="none"
    className={className}
    style={{
      transform: direction === "down" ? "rotate(180deg)" : undefined,
      marginInlineEnd: 4,
      verticalAlign: "middle",
      display: "inline-block",
      ...style,
    }}
  >
    <path
      d="M4.51133 2.0498L5.14772 1.41341L4.51133 0.777012L3.87493 1.41341L4.51133 2.0498ZM3.61133 11.0498C3.61133 11.5469 4.01427 11.9498 4.51133 11.9498C5.00838 11.9498 5.41133 11.5469 5.41133 11.0498L3.61133 11.0498ZM8.74772 5.01341L5.14772 1.41341L3.87493 2.6862L7.47493 6.2862L8.74772 5.01341ZM3.87493 1.41341L0.274932 5.01341L1.54772 6.2862L5.14772 2.6862L3.87493 1.41341ZM3.61133 2.0498L3.61133 11.0498L5.41133 11.0498L5.41133 2.0498L3.61133 2.0498Z"
      fill={color || "#395AA1"}
    />
  </svg>
)

export default InvestChangeArrow
